/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetSsoConfigurationRequest } from '../../models/get-sso-configuration-request';
import { GetSsoConfigurationResponse } from '../../models/get-sso-configuration-response';

export interface GetSingleSignOnConfiguration$Params {
  
    /**
     * Request for single sign on configuration
     */
    body: GetSsoConfigurationRequest
}

export function getSingleSignOnConfiguration(http: HttpClient, rootUrl: string, params: GetSingleSignOnConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSsoConfigurationResponse>> {
  const rb = new RequestBuilder(rootUrl, getSingleSignOnConfiguration.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetSsoConfigurationResponse>;
    })
  );
}

getSingleSignOnConfiguration.PATH = '/v1/configuration/employees/sso';
